import sectionGuaranteedSafeCheckout02Css from '../css-snippets/section-guaranteed-safe-checkout-02';

const html = `
<style>${sectionGuaranteedSafeCheckout02Css}</style>
<div
  id="guaranteed-safe-checkout-section-unique-id"
  data-id="unique-id"
  class="guaranteed-safe-checkout-section"
  data-attribute="guaranteed-safe-checkout-section"
  data-title="Guaranteed Safe Checkout"
  data-image-position="left"
>
  <div
    data-attribute="guaranteed-safe-checkout-container"
    class="guaranteed-safe-checkout-container"
    data-container-align-items="center"
    data-container-border-enabled="false"
    data-container-border-color="#e5e7eb"
    data-container-gap="10"
    data-mobile-column="false"
  >
    <div
      class="guaranteed-safe-checkout-image"
      data-attribute="guaranteed-safe-checkout-image"
      data-show-image="true"
      data-image-width-desktop="160"
      data-image-width-mobile="70"
    >
      <img
        src="https://cdn.skyfastimg.com/images/2026/03/26/image-69c49334ed4eac82f7081301.webp?w=400&h=200&q=80"
        alt="Guaranteed Safe Checkout"
      />
    </div>
    <div class="guaranteed-safe-checkout-content" data-attribute="guaranteed-safe-checkout-content">
      <h2>
        <strong> 30-DAY MONEY-BACK GUARANTEE 1</strong>
      </h2>
      <p>
        If FurSure doesn't work for your dog, we don't want your money. We know that switching from chemicals takes
        trust, and we want you to feel that trust is earned.
      </p>
    </div>
  </div>
</div>
`;

export default html;
